module.exports = __webpack_public_path__ + "img/slide.64532517.jpg";